<template>
  <v-expansion-panels :value="null">
    <v-expansion-panel>
      <v-expansion-panel-header class="expansion-panel-border green">
        <v-row>
          <v-icon>settings</v-icon>
          <h3 class="title text-uppercase ml-3">
            Сервіси
            <span v-if="services.length">({{ services.length }})</span>
          </h3>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row v-if="services.length">
          <v-col>
            <v-tabs
              v-model="activeTab"
            >
              <v-tab
                v-for="serviceType in uniqueServiceTypes"
                :key="serviceType.id"
              >
                {{ serviceType.title }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="activeTab">
              <v-tab-item
                v-for="(serviceType, index) in uniqueServiceTypes"
                :key="`service-${index}`"
              >
                <v-data-table
                  :headers="headers"
                  :items="getServicesByType(serviceType)"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  hide-default-footer
                  class="elevation-0"
                >
                  <template v-slot:item="{ item }">
                    <tr
                      :class="`${item.color} lighten-4`"
                    >
                      <td>
                        {{ item.title }}
                      </td>
                      <td>
                        {{ item.payedTo | date }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <h4>
              Щоб додати сервіс зверніться до менеджера
            </h4>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  data: () => ({
    activeTab: "",
    headers: [
      {
        value: "title", 
        width: "80%", 
        sortable: false
      },
      {
        value: "payedTo",
        text: "Сплачено до",
        sortable: false,
      }
    ],
    sortBy: "payedTo",
    sortDesc: true,
  }),
  computed: {
    ...mapState("client", ["services"]),
    ...mapGetters("client", ["getServicesByType", "uniqueServiceTypes"]),
  },
  watch: {
    uniqueServiceTypes(val) {
      this.activeTab = val[0];
    },
  },
};
</script>